import CategoriesListPage from 'src/pages/CategoriesListPage';
import ProductListPage from 'src/pages/ProductListPage';
import { useProductsListQuery } from 'src/providers/useProductsListQuery';
import { useUser } from 'src/providers/User';

export default function ProductListings() {
  /* istanbul ignore next */
  const { isLoading, isError, data: products = [] } = useProductsListQuery();
  const { productCategories } = useUser();

  return productCategories?.length ? (
    <CategoriesListPage
      productCategories={productCategories}
      isLoading={isLoading}
      isError={isError}
      products={products}
    />
  ) : (
    <ProductListPage isLoading={isLoading} isError={isError} products={products} />
  );
}
